export type WorkspaceWindowKind = 'iframe' | 'panel' | 'placeholder';

export interface WorkspaceWindowModel {
  id: string;
  title: string;
  kind: WorkspaceWindowKind;
  /** Weltkoordinaten (px) */
  x: number;
  y: number;
  width: number;
  height: number;
  /** iframe src oder Panel-Key */
  payload?: string;
  accent?: 'cyan' | 'blue' | 'purple' | 'emerald';
}

export const DONNA_WORLD = {
  width: 6400,
  height: 6400,
  hubX: 3200,
  hubY: 3200,
} as const;

export const WORKSPACE_PRESETS: Record<
  string,
  Omit<WorkspaceWindowModel, 'id' | 'x' | 'y'> & { offsetX: number; offsetY: number }
> = {
  chat: {
    title: 'Donna Chat',
    kind: 'panel',
    payload: 'donna-chat',
    width: 420,
    height: 480,
    offsetX: 380,
    offsetY: -40,
    accent: 'cyan',
  },
  pipeline: {
    title: 'Mandanten Pipeline',
    kind: 'panel',
    payload: 'pipeline',
    width: 420,
    height: 320,
    offsetX: 520,
    offsetY: -180,
    accent: 'emerald',
  },
  healthMap: {
    title: 'CEO Ops Health Map',
    kind: 'iframe',
    payload: '/health-map/index.html',
    width: 520,
    height: 380,
    offsetX: -580,
    offsetY: -120,
    accent: 'cyan',
  },
  brain: {
    title: 'ARKORBIT BRAIN',
    kind: 'panel',
    payload: 'brain',
    width: 380,
    height: 280,
    offsetX: 480,
    offsetY: 320,
    accent: 'purple',
  },
  workflows: {
    title: 'Frankfurt Node',
    kind: 'iframe',
    payload: 'https://n8n.arkorbit.at',
    width: 440,
    height: 300,
    offsetX: -520,
    offsetY: 280,
    accent: 'blue',
  },
};
